import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { TranslocoService, Translation, TranslocoScope } from '@jsverse/transloco';
import { Language } from './models';

// TODO: needed until reexported https://github.com/jsverse/transloco/issues/877
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type HashMap<T = any> = Record<string, T>;

@Injectable()
export class I18Service {
  private readonly translocoService = inject(TranslocoService);

  language$ = new BehaviorSubject<Language>(this.getActiveLanguage());

  getAvailableLangs(): Language[] {
    return this.translocoService.getAvailableLangs() as Language[];
  }

  setActiveLanguage(lang: Language): Promise<Translation> {
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translocoService.setActiveLang(lang);
    this.language$.next(lang);
    return lastValueFrom(this.translocoService.load(lang));
  }

  getActiveLanguage(): Language {
    return this.translocoService.getActiveLang() as Language;
  }

  translate(key: string, args?: HashMap, lang?: string | TranslocoScope | TranslocoScope[]): Observable<string> {
    return this.translocoService.selectTranslate(key, args, lang);
  }

  get(key: string, args?: HashMap): string {
    return this.translocoService.translate(key, args);
  }
}
